export async function getAuthUserData() {
  const accessToken = await getAccessToken();

  if (!accessToken) {
    return null;
  }

  try {
    const accessTokenInfo = accessToken.split(".")[1];
    if (!accessTokenInfo) {
      return null;
    }

    const parsedTokenData = JSON.parse(atob(accessTokenInfo));

    if (!parsedTokenData || typeof parsedTokenData !== "object") {
      return null;
    }

    return {
      customerId:
        "https://www.johnlewis.com/auth/customerId" in parsedTokenData
          ? String(parsedTokenData["https://www.johnlewis.com/auth/customerId"])
          : "",
      email:
        "https://www.johnlewis.com/auth/email" in parsedTokenData
          ? String(parsedTokenData["https://www.johnlewis.com/auth/email"])
          : "",
    };
  } catch {
    return null;
  }
}

let retryCount = 0;

export async function getAccessToken(): Promise<string | null | undefined> {
  const auth0 = window.__auth0__ || window.auth0;

  if (auth0) return await auth0.getTokenIfAuthenticated();

  if (retryCount < 5) {
    await delay(200);
    retryCount += 1;
    return await getAccessToken();
  }

  return;
}

function delay(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
